import { useState } from 'react';
import { ChevronDown, MessageCircle } from 'lucide-react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How long does a typical exchange take?',
      answer: 'Most exchanges are completed within 2-10 minutes. The exact time depends on the blockchain network conditions of the currencies being exchanged. Bitcoin transactions may take longer due to confirmation requirements, while Ethereum and other faster networks typically complete in under 3 minutes.',
    },
    {
      question: 'Do I need to create an account or verify my identity?',
      answer: 'No, Omini Bridge is a non-custodial exchange that requires no registration or KYC verification for most transactions. Simply enter your wallet address and exchange directly. However, in rare cases of suspicious activity, we may request additional verification.',
    },
    {
      question: 'Is Omini Bridge safe and secure?',
      answer: 'Absolutely. We are a non-custodial exchange, meaning we never hold your funds. Your cryptocurrencies are exchanged directly between wallets. We use industry-standard encryption, secure servers, and have undergone multiple security audits. Our platform has processed over $2 billion in transactions with a 99.9% success rate.',
    },
    {
      question: 'What happens if I send the wrong amount?',
      answer: 'If you send less than the minimum required amount, the exchange will not be processed and you\'ll need to contact our support team for a refund. If you send more than specified, the excess amount will be automatically exchanged at the current rate and sent to your destination address. Always double-check amounts before sending.',
    },
    {
      question: 'Can I cancel an exchange after sending funds?',
      answer: 'Once you\'ve sent funds to the deposit address, the exchange process begins automatically and cannot be canceled. This is because blockchain transactions are irreversible. Please make sure all details are correct before sending any funds.',
    },
    {
      question: 'What are the exchange limits?',
      answer: 'Omini Bridge has no upper limits on exchanges. The minimum amount varies by currency pair and is displayed in the exchange widget. For very large exchanges (over $100,000), we recommend contacting our support team for the best rates and personalized service.',
    },
    {
      question: 'How are exchange rates determined?',
      answer: 'Our rates are aggregated from multiple liquidity providers to ensure you get the best possible price. Rates are calculated in real-time and locked for 2 minutes once you start an exchange. We charge a small service fee of 0.5% which is already included in the displayed rate.',
    },
  ];

  return (
    <section className="faq-section" id="faq">
      <div className="section-container">
        <div className="faq-layout">
          <div className="faq-header">
            <span className="section-label">
              <span className="label-dot" />
              FAQ
            </span>
            <h2 className="section-title">
              Frequently Asked{' '}
              <span className="gradient-text">Questions</span>
            </h2>
            <p className="section-subtitle">
              Got questions? We&apos;ve got answers. If you can&apos;t find what you&apos;re looking for, 
              feel free to contact our support team.
            </p>
            
            <div className="support-cta">
              <div className="support-icon">
                <MessageCircle />
              </div>
              <div className="support-info">
                <span className="support-title">Still have questions?</span>
                <span className="support-text">Our team is here to help 24/7</span>
              </div>
              <a href="/contact" className="support-btn">Contact Support</a>
            </div>
          </div>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                >
                  <span>{faq.question}</span>
                  <ChevronDown className="faq-chevron" />
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
